import { useState } from "react";
import { Lock, Share2 } from "lucide-react";
import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";
import reportHeader from "@/assets/report-header.jpg";
export function ReportPreview() {
  const t = useT();
  const bars = t.areas.items.map((a, i) => ({
    label: a.label,
    max: a.max,
    value: [14, 12, 9, 15, 11, 7][i] ?? 0
  }));
  const [tab, setTab] = useState(0);
  return <section id="bericht" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <Reveal>
          <h2 className="text-2xl font-bold text-[#0F172A] sm:text-3xl">{t.report.title}</h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#64748B]">{t.report.lead}</p>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-12 overflow-hidden rounded-3xl border border-[#E8ECF1] bg-white shadow-[0_18px_50px_rgba(15,23,42,0.06)]">
            {/* Browser-Rahmen */}
            <div className="flex items-center gap-2 border-b border-black/5 bg-[#F1F5F9] px-4 py-3">
              <span className="h-2.5 w-2.5 rounded-full bg-[#F87171]" aria-hidden />
              <span className="h-2.5 w-2.5 rounded-full bg-[#FCD34D]" aria-hidden />
              <span className="h-2.5 w-2.5 rounded-full bg-[#4ADE80]" aria-hidden />
              <span className="ml-3 truncate rounded-full bg-white px-3 py-1 text-[11px] text-[#94A3B8]">
                positivup.com/bericht/beispiel
              </span>
              <Share2 size={14} aria-hidden className="ml-auto shrink-0" style={{
              color: "#94A3B8"
            }} />
            </div>

            {/* Foto-Header */}
            <div className="relative">
              <img src={reportHeader} alt="Beispielhafter Betrieb: Ladenfront eines Friseursalons in einer Stadtstraße" loading="lazy" width={1280} height={512} className="h-32 w-full object-cover sm:h-44" />
              <div className="absolute inset-0" style={{
              backgroundImage: "linear-gradient(to top, rgba(10,37,57,0.85), rgba(10,37,57,0.15))"
            }} />
              <div className="absolute bottom-4 left-5 right-5">
                <p className="text-sm font-semibold text-white sm:text-base">{t.report.business}</p>
                <p className="text-[11px] text-white/65">{t.report.note}</p>
              </div>
            </div>

            {/* Tab-Leiste */}
            <div role="tablist" aria-label="Berichtsbereiche" className="flex gap-1 overflow-x-auto border-b border-black/5 px-3 py-2">
              {t.report.tabs.map((label, i) => <button key={label} role="tab" id={`report-tab-${i}`} aria-selected={tab === i} aria-controls="report-panel" tabIndex={tab === i ? 0 : -1} onKeyDown={e => {
              if (e.key === "ArrowRight") setTab(v => (v + 1) % t.report.tabs.length);
              if (e.key === "ArrowLeft") setTab(v => (v - 1 + t.report.tabs.length) % t.report.tabs.length);
            }} onClick={() => setTab(i)} className="shrink-0 rounded-full px-3.5 py-2 text-xs font-semibold transition-colors focus-visible:ring-2 focus-visible:ring-[#3B82F6] focus-visible:outline-none" style={tab === i ? {
              backgroundColor: "#0F172A",
              color: "#FFFFFF"
            } : {
              color: "#94A3B8"
            }}>
                  {label}
                </button>)}
            </div>

            <div role="tabpanel" id="report-panel" aria-labelledby={`report-tab-${tab}`} className="grid gap-6 p-5 sm:grid-cols-[auto_1fr] sm:p-7">
              <div className="rounded-2xl bg-[#FAFBFC] p-5 text-center">
                <p className="text-4xl font-bold text-[#0F172A]">68</p>
                <p className="mt-1 text-xs text-[#94A3B8]">von 100 Punkten</p>
                <div aria-hidden className="mx-auto mt-4 h-1.5 w-24 rounded-full" style={{
                backgroundImage: "linear-gradient(90deg,#3B82F6,#93C5FD)"
              }} />
                <p className="mt-4 text-xs leading-relaxed text-[#94A3B8]">
                  Maps-Position 6,4<br />Verzeichnisse 7 · NAP 82 %
                </p>
              </div>

              <div>
                <ul className="space-y-3">
                  {bars.map(b => <li key={b.label}>
                      <div className="flex items-baseline justify-between gap-3 text-xs">
                        <span className="font-medium text-[#475569]">{b.label}</span>
                        <span className="text-[#94A3B8] tabular-nums">
                          {b.value}/{b.max}
                        </span>
                      </div>
                      <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-[#E8ECF1]">
                        <div className="h-full rounded-full" style={{
                      width: `${b.value / b.max * 100}%`,
                      backgroundImage: "linear-gradient(90deg,#3B82F6,#93C5FD)"
                    }} />
                      </div>
                    </li>)}
                </ul>

                <ul className="mt-6 space-y-2">
                  {t.report.lockedRows.map(row => <li key={row} className="flex items-center justify-between gap-3 rounded-xl border border-black/5 bg-[#FAFBFC] px-3 py-2.5">
                      <span className="truncate text-xs text-[#94A3B8] blur-[3px] select-none" aria-hidden>
                        {row}
                      </span>
                      <span className="inline-flex shrink-0 items-center gap-1.5 text-[11px] font-semibold text-[#94A3B8]">
                        <Lock size={12} aria-hidden /> {t.report.locked}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}